/**
 * CustomerSelectorHeader - Header section with title, description, error and empty state
 */

import { Email } from "@mui/icons-material";
import { Alert, Box, Link, Typography } from "@mui/material";

interface CustomerSelectorHeaderProps {
  error: string | null;
  hasNoCustomers: boolean;
  loading: boolean;
  isInAddCustomersToShipmentModal?: boolean;
}

export function CustomerSelectorHeader({
  error,
  hasNoCustomers,
  loading,
  isInAddCustomersToShipmentModal = false,
}: CustomerSelectorHeaderProps) {
  return (
    <>
      {isInAddCustomersToShipmentModal && (
        <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
          Only people not already on the shipment are listed below.
        </Typography>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 1 }}>
          {error}
        </Alert>
      )}

      {hasNoCustomers && !loading && (
        <Box sx={{ textAlign: "center", py: 3, mb: 2 }}>
          <Email sx={{ fontSize: 48, color: "text.disabled", mb: 1 }} />
          <Typography variant="body1" color="textSecondary" sx={{ mb: 1 }}>
            No customers in your network yet!
          </Typography>
          <Typography variant="body2" color="textSecondary">
            You can still enter email addresses to invite new customers, or{" "}
            <Link
              href="/supplier-network"
              target="_blank"
              rel="noopener noreferrer"
            >
              manage your customer network
            </Link>
            .
          </Typography>
        </Box>
      )}
    </>
  );
}
